// src/components/products/ProductForm/helpers/formConstants.js

/**
 * ✅ Initial form data structure
 */
export const INITIAL_FORM_DATA = {
    // Step 1
    product_type_id: null,
    selectedProductType: null,
    supplier_ids: [],

    // Step 2 - Transfer
    operating_hours_start_time: "",
    operating_hours_end_time: "",
    itinerary: { ar: "", en: "" },
    notes: { ar: "", en: "" },

    // Step 2 - Tour
    package_id: null,
    type: "default",
    default_itinerary: { ar: "", en: "" },
    morning_operating_hours_start_time: "",
    morning_operating_hours_end_time: "",
    evening_operating_hours_start_time: "",
    evening_operating_hours_end_time: "",
    morning_itinerary: { ar: "", en: "" },
    evening_itinerary: { ar: "", en: "" },
    highlights: { ar: "", en: "" },
    long_description: { ar: "", en: "" },
    what_to_bring: { ar: "", en: "" },
    voucher_notes: { ar: "", en: "" },
    free_transfer_areas: { ar: "", en: "" },
    extra_charge_transfer_areas: { ar: "", en: "" },

    // Step 3 - General
    category_id: null,
    transportation_id: null,
    service_id: null,
    title: { ar: "", en: "" },
    pricing_unit_id: null,
    price_type: { ar: "", en: "" },
    operating_days: { ar: "", en: "" },
    operating_type: { ar: "", en: "" },
    short_description: { ar: "", en: "" },
    summary: { ar: "", en: "" },
    inclusions: { ar: "", en: "" },
    exclusions: { ar: "", en: "" },
    cancellation_and_change_policy: { ar: "", en: "" },
    locations: { ar: "", en: "" },
    cover_image: null,
    cover_image_preview: "",
    uploadingCoverImage: false,
    coverImageError: "",
    coverImageSuccess: "",
    images: [],
    uploadedImages: [],

    // Rate Availability
    rate_availability_start_date: "",
    rate_availability_end_date: "",

    // Auto/Hidden
    currency_id: null,
    rate_availability: null,
};

/**
 * ✅ Product type identifiers
 */
export const PRODUCT_TYPES = {
    TRANSFER: 'transfer',
    TOUR: 'tour',
};

/**
 * ✅ Tour types
 */
export const TOUR_TYPES = {
    DEFAULT: 'default',
    MORNING_EVENING: 'morning_and_evening',
};

/**
 * ✅ Form steps configuration
 */
export const getFormSteps = (isArabic) => [
    { label: isArabic ? "نوع المنتج" : "Product Type" },
    { label: isArabic ? "المعلومات العامة" : "General Info" },
    { label: isArabic ? "تفاصيل المنتج" : "Product Details" },
];
